export const encodeEmail = (email: string): string => {
  return email.split('').map(char => `&#${char.charCodeAt(0)};`).join('');
};

export const decodeEmail = (encodedEmail: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(encodedEmail, 'text/html');
  return doc.body.textContent || '';
};